import { api } from './api';

// Upload image via backend API
export const uploadImage = async (file, path) => {
  try {
    const result = await api.uploadImage(file, path);
    if (result.error) {
      throw new Error(result.error);
    }
    return result.data.url;
  } catch (error) {
    console.error('Error uploading image:', error);
    throw error;
  }
};

// Upload multiple images via backend API
export const uploadImages = async (files, basePath) => {
  try {
    const result = await api.uploadImages(files, basePath);
    if (result.error) {
      throw new Error(result.error);
    }
    return result.data.urls;
  } catch (error) {
    console.error('Error uploading images:', error);
    throw error;
  }
};

